<div class="page">
  <div *ngIf="selectedUser" #signatureBlock class="signature-preview" style="height: 200px; width: 400px; padding: 18px;margin: 0;">
    <div style="display: inline-block;height: 100px;
    vertical-align: top;
    line-height: 100px;padding-right: 20px;">
      <img *ngIf="selectedUser?.image" [src]="selectedUser?.image" alt="profile" border="0"
        style="width: 90px;height: 90px;margin: 0;vertical-align: middle;border-radius: 50%;object-fit: cover;">
    </div>
    <div style="display: inline-block;vertical-align: top;padding-left: 0px;">
      <a href="https://element.com.mx/">
        <img [src]="assetUrl('assets/images/element.png')" alt="Element" style="width: 125px;height: 39px;">
      </a>
      <div class="info-signature" style="width: 285px; margin: 0px auto;text-align: left;">
        <img [src]="assetUrl('assets/images/signature-line.png')" alt="signature-line" border="0"
          style="width: 250px;margin: 10px auto;">
        <div>
          <div style="display: inline-block;">
            <span style="color: #000;
          font-family: Helvetica;
          font-size: 15px;
          font-style: normal;
          font-weight: 700;
          line-height: 17px;">
              {{selectedUser?.name}}</span>
            <div>
              <span style="color: #000;
          font-family: Helvetica;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 15px;
          text-align: left;">
                {{selectedUser?.job}}
              </span>
            </div>
          </div>
          <div style="display: inline-block;margin-left: 20px;">
            <div style="height: 16px;">
              <a [href]="'tel:' + selectedUser?.phone" style="color: #000;
                  font-family: Helvetica;
                  font-size: 11px;
                  font-style: normal;
                  font-weight: 400;
                  text-decoration: none;">
                m. {{selectedUser?.phone}}
              </a>
            </div>
            <div *ngIf="selectedUser?.email" style="height: 16px;">
              <a [href]="'mailto:' + selectedUser?.email" style="color: #000;
                  font-family: Helvetica;
                  font-size: 11px;
                  font-style: normal;
                  font-weight: 400;
                  text-decoration: none;">
                {{selectedUser?.email}}
              </a>
            </div>
            <div style="text-align: left;">
              <a href="https://element.com.mx/" target="_blank" rel="noopener noreferrer" style="color: #000;
    font-family: Helvetica;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    text-decoration-line: underline;
    text-align: left;">
                element.com.mx
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions" *ngIf="selectedUser">
    <button type="button" class="copy-btn" (click)="copySignature()">Copiar firma</button>
    <p class="copy-message" *ngIf="copyMessage">{{ copyMessage }}</p>
    <p class="copy-hint">Pega con Ctrl+V (Cmd+V en Mac) en la configuración de firma de tu correo.</p>
  </div>
</div>
